import { useTranslation } from "react-i18next";
import type { ComponentProps } from "react";
import { CollapsibleAlert } from "molecules/collapsible-alert/CollapsibleAlert";

type Props = Omit<
	ComponentProps<typeof CollapsibleAlert>,
	"variant" | "summary" | "children"
> & {
	companies: { id: string; name: string }[];
};

export const UnorganizedCompaniesAlert = ({ companies, ...rest }: Props) => {
	const { t } = useTranslation();

	if (companies.length === 0) {
		return null;
	}

	return (
		<CollapsibleAlert
			{...rest}
			variant="warning"
			summary={t("{{count}} company is not yet part of the group structure", {
				count: companies.length,
			})}
		>
			<ul className="pt-2 pl-6 list-disc">
				{companies.map((company) => (
					<li key={company.id} className="list-item">
						{company.name}
					</li>
				))}
			</ul>
		</CollapsibleAlert>
	);
};
